import React, { useMemo } from 'react';
import '../styles/PriceCeilingShowcase.css';
import Badge from './Badge';
import { Top } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function PriceCeilingShowcase(props) {
    const ceilings = useMemo(() => props.ceilings || [], [props.ceilings]);
    const allComps = useMemo(() => props.allComps || [], [props.allComps]);
    const darkMode = props.darkMode || false;

    // Find the ceiling property from allComps
    const ceilingProperty = useMemo(() => {
        if (!ceilings || ceilings.length === 0) return null;
        const ceilingZpid = ceilings[0].zpid;
        return allComps.find(c => c.uniqueIds.zillowId === ceilingZpid) || null;
    }, [ceilings, allComps]);

    // Return null if no ceiling exists
    if (!ceilingProperty || !ceilings || ceilings.length === 0) {
        return null;
    }

    const ceilingDescription = ceilings[0].description || '';
    const ceilingCount = ceilings.length;
    const analysisText = `We found ${ceilingCount} price ceiling${ceilingCount !== 1 ? 's' : ''} to help determine our max price.`;

    // Get first image from the ceiling property
    const firstImage = ceilingProperty?.listingDetails?.mlsPhotoUrls?.[0] || null;
    const address = ceilingProperty?.addressDetails?.streetAddress || '';

    const textColorClass = darkMode ? 'colour-white' : 'colour-primary';
    const containerClass = darkMode ? 'bg-colour-dark-mode' : 'bg-colour-white';

    return (
        <div className={`price-ceiling-showcase-container ${containerClass}`}>
            {/* Header Section */}
            <div className="price-ceiling-showcase-header-section">
                <h3 className={`heading-small-bold ${textColorClass}`}>
                    Price ceilings
                </h3>
                {analysisText && (
                    <p className={`body-regular ${textColorClass}`}>
                        {analysisText}
                    </p>
                )}
            </div>

            {/* Body Section */}
            <div className="price-ceiling-showcase-body-section">
                {firstImage && (
                    <div className="price-ceiling-showcase-image-container">
                        <img
                            src={firstImage}
                            alt={address}
                            className="price-ceiling-showcase-image"
                        />
                    </div>
                )}
                <div className="price-ceiling-showcase-content">
                    {address && (
                        <h4 className={`body-bold ${textColorClass}`}>
                            {address}
                        </h4>
                    )}
                    <Badge
                        bgColour="bg-colour-red-01"
                        statusDot={false}
                        statusDotColour={null}
                        text="Price ceiling"
                        textClass="body-regular colour-primary"
                        icon={<Top fill={colour.red02} size={16} />}
                        tooltip={false}
                        tooltipBody={null}
                        tooltipPosition={null}
                        iconLeft={true}
                    />
                    {ceilingDescription && (
                        <p className={`body-regular ${textColorClass}`}>
                            {ceilingDescription}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PriceCeilingShowcase;

